/* eslint-disable max-len */
import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

const WarehouseIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <path fillRule="evenodd" clipRule="evenodd" d="M9.50489 4.65405L17.0098 9.42989V17.829C17.0098 18.4211 16.7073 18.9722 16.2077 19.2901L10.4347 22.9639C9.8674 23.3249 9.14239 23.3249 8.57508 22.9639L2.80208 19.2901C2.30252 18.9722 2 18.4211 2 17.829V10.3806C2 9.78848 2.30252 9.23738 2.80208 8.91948L9.50489 4.65405ZM4.3092 12.167L8.35029 14.7386V20.0837L4.3092 17.5121V12.167ZM10.6595 20.0837L14.7006 17.5121V12.167L10.6595 14.7386V20.0837ZM9.50489 12.7362L13.7046 10.0637L9.50489 7.39117L5.30519 10.0637L9.50489 12.7362Z" fill="currentColor" />
            <path fillRule="evenodd" clipRule="evenodd" d="M13.3068 0.588445C13.6582 0.237032 14.1951 0.149912 14.6396 0.372166L21.5672 3.83596C22.2721 4.1884 22.4245 5.12783 21.8673 5.68509L16.594 10.9584L8.24796 5.64731L13.3068 0.588445ZM14.3512 2.80974L11.9163 5.24462L16.2709 8.01573L19.1017 5.18497L14.3512 2.80974Z" fill="currentColor" />
        </SvgIcon>
    );
};

export default WarehouseIcon;
